import { Button } from "@/common/components/button";
import Table from "@/common/components/Table";
import { H3 } from "@/common/elements/headings";
import {
  batchTableHeadersPreview,
  batchTableKeysPreview,
  getBatchTableDataPreview,
  getLogisticPreviewDetails,
  getOtherDetails,
  getProductDetails,
} from "../data";
import { KeyValueObj } from "@/common/types";
import { DeliveryWrapper } from "../styles";
import { KeyValue } from "@/common/components/key-value";

interface IPreviewProps {
  batchData?: any;
  deliveryData?: any;
  productBatches: any;
  formData?: KeyValueObj;
  onBack: () => void;
  setFormData?: React.Dispatch<React.SetStateAction<KeyValueObj>>;
  loading?: boolean;
}

export default function Preview({
  productBatches,
  formData,
  setFormData,
  onBack,
  loading,
}: IPreviewProps) {
  const tableData = Object.values(productBatches).flat();

  return (
    <>
      <DeliveryWrapper>
        <H3>Batch Selection</H3>
        <Table
          tableHeaders={batchTableHeadersPreview}
          tableKeys={batchTableKeysPreview}
          removeFilters
          tableData={getBatchTableDataPreview(tableData) || []}
          full
          rowLineColor="light"
        />
        <div className="separate"></div>
        <H3>Delivery Infomation</H3>

        <div className="double-column-wrapper">
          {getLogisticPreviewDetails(formData)?.map((company, index) => (
            <div key={company.companyName || index} className="">
              <h3>{company.companyName}</h3>

              {company.details.map((detailsItem, i) => (
                <KeyValue
                  key={i}
                  title={detailsItem.title}
                  value={detailsItem.value}
                />
              ))}
            </div>
          ))}
        </div>

        <div className="separate"></div>
        <H3>Product details</H3>
        <div className="double-column-wrapper">
          {getProductDetails(formData)?.map(
            (details: KeyValueObj, i: number) => (
              <KeyValue key={i} title={details?.title} value={details?.value} />
            ),
          )}
        </div>

        <div className="separate"></div>
        <H3>Other details</H3>
        <div className="double-column-wrapper">
          {getOtherDetails(formData as any)?.map(
            (details: KeyValueObj, i: number) => (
              <KeyValue key={i} title={details?.title} value={details?.value} />
            ),
          )}
        </div>

        <div className="flex-row  gap-5 mt-10  p-5 pb-20">
          <Button secondary onClick={onBack}>
            Back
          </Button>
          <Button loading={loading} onClick={setFormData}>
            Submit
          </Button>
        </div>
      </DeliveryWrapper>
    </>
  );
}
